// RESONATE_PERF_V1 - locally-hosted, optimised WebP integration logos
const tools = [
  ["LinkedIn", "linkedin"],
  ["Notion", "notion"],
  ["Slack", "slack"],
  ["Google Drive", "google-drive"],
  ["Gmail", "gmail"],
  ["Google Sheets", "google-sheets"],
  ["Google Docs", "google-docs"],
  ["Google Slides", "google-slides"],
  ["Salesforce", "salesforce"],
  ["HubSpot", "hubspot"],
  ["Discord", "discord"],
  ["Wix", "wix"],
  ["GitHub", "github"],
  ["BambooHR", "bamboohr"],
  ["ClickUp", "clickup"],
  ["Wrike", "wrike"],
  ["Box", "box"],
  ["Outlook", "outlook"],
  ["Linear", "linear"],
  ["Dropbox", "dropbox"],
  ["Airtable", "airtable"],
  ["Microsoft Teams", "microsoft-teams"],
  ["SharePoint", "sharepoint"],
  ["OneDrive", "onedrive"],
  ["Typeform", "typeform"],
  ["Calendly", "calendly"],
  ["Contentful", "contentful"],
  ["Substack", "substack"],
];

export const Marquee = () => (
  <section data-testid="marquee-section" className="py-14 border-y border-[#E5E7EB] bg-white relative overflow-hidden">
    <p className="text-center text-[11px] uppercase tracking-[0.18em] text-[rgba(17,24,39,0.65)] mb-8 font-medium">
      Pulls ideas from your entire stack
    </p>
    <div
      className="relative"
      style={{
        maskImage: "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)",
        WebkitMaskImage: "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)",
      }}
    >
      {/* Single pass on mobile (14 icons), double pass on desktop (28 x 2) so
          the infinite-scroll effect still works at wide viewports. Halves the
          DOM node count on mobile, which was previously 56 children. */}
      <div className="flex marquee-anim w-max items-center gap-14 px-5 md:hidden">
        {tools.slice(0, 14).map(([name, slug], i) => (
          <div
            key={`m-${name}-${i}`}
            data-testid={`marquee-logo-${slug}-${i}`}
            className="flex items-center opacity-80"
            title={name}
          >
            <img
              src={`/integrations/${slug}.webp`}
              alt={`${name} integration logo - connect ${name} to Resonate`}
              loading="lazy"
              decoding="async"
              width="48"
              height="48"
              className="h-12 w-12 object-contain select-none"
              draggable="false"
            />
          </div>
        ))}
      </div>
      <div className="hidden md:flex marquee-anim w-max items-center gap-14 px-5">
        {[...tools, ...tools].map(([name, slug], i) => (
          <div
            key={`${name}-${i}`}
            data-testid={`marquee-logo-${slug}-${i}`}
            className="flex items-center opacity-80 hover:opacity-100 transition-opacity duration-300"
            title={name}
          >
            <img
              src={`/integrations/${slug}.webp`}
              alt={`${name} integration logo - connect ${name} to Resonate`}
              loading="lazy"
              decoding="async"
              width="48"
              height="48"
              className="h-12 w-12 object-contain select-none"
              draggable="false"
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);
